import {
  forgotPassword,
  login,
  resetPassword,
  verifyResetPassword
} from "../api-helpers/api-auth";

export default {
  state: {
    isLoggingIn: false,
    isForgettingPassword: false,
    isVerifyingResetPassword: false,
    isResettingPassword: false
  },
  mutations: {
    setIsLoggingIn(state, bool) {
      state.isLoggingIn = bool;
    },
    setIsForgettingPassword(state, bool) {
      state.isForgettingPassword = bool;
    },
    setIsVerifyingResetPassword(state, bool) {
      state.isVerifyingResetPassword = bool;
    },
    setIsResettingPassword(state, bool) {
      state.isResettingPassword = bool;
    }
  },
  actions: {
    async login({ state, commit }, data) {
      let response;
      if (!state.isLoggingIn) {
        commit("setIsLoggingIn", true);

        response = await login(data.email, data.password);
        commit("setUserInfo");

        commit("setIsLoggingIn", false);
      }
      return response;
    },
    async forgotPassword({ state, commit }, email) {
      let statusAndMessage;
      if (!state.isForgettingPassword) {
        commit("setIsForgettingPassword", true);

        statusAndMessage = await forgotPassword(email);

        commit("setIsForgettingPassword", false);
      }
      return statusAndMessage;
    },
    async verifyResetPassword({ state, commit }, data) {
      let statusAndMessage;
      if (!state.isVerifyingResetPassword) {
        commit("setIsVerifyingResetPassword", true);

        statusAndMessage = await verifyResetPassword(data);

        commit("setIsVerifyingResetPassword", false);
      }
      return statusAndMessage;
    },
    async resetPassword({ state, commit }, data) {
      let statusAndMessage;
      if (!state.isResettingPassword) {
        commit("setIsResettingPassword", true);

        statusAndMessage = await resetPassword(data);

        commit("setIsResettingPassword", false);
      }
      return statusAndMessage;
    }
  }
};
